import React from "react"
import Loading from "../Loading"

const Message = ({
	endOfRound,
	endOfGame,
	categorySelect,
	loading,
	category,
	newHighScore,
	round,
	gotAllTheAnswers,
	qotd,
	score,
	averageScore,
	showResults,
}) => {
	if (categorySelect) {
		if (loading) {
			return <Loading />
		}
		return <h2>Choose A Category</h2>
	}
	if (endOfGame) {
		if (qotd) {
			const scoreDiff = (
				<span style={{ color: "var(--blue)" }}>
					{Math.floor(Math.abs(score - averageScore)).toLocaleString()}
				</span>
			)
			if (score > averageScore) {
				return <h2>You scored {scoreDiff} points better than average. Nice!</h2>
			}
			if (score < averageScore) {
				return (
					<h2>
						You scored {scoreDiff} points under average.
						Try&nbsp;again&nbsp;tomorrow!
					</h2>
				)
			}
			return <h2>You tied the average score for today. Not bad!</h2>
		}
		if (gotAllTheAnswers) {
			return <h2>PERFECT SCORE!!!!1</h2>
		}
		if (newHighScore) {
			return <h2>You've set a new high score!</h2>
		}
		if (showResults) {
			return (
				<h2>
					Score Summary - <u>{category}</u>
				</h2>
			)
		}
		return <h2>Game Over!</h2>
	}
	if (endOfRound) {
		return (
			<h2>
				Ready for Round {round + 1} of{" "}
				<span style={{ textDecoration: "underline" }}>{category}</span>?
			</h2>
		)
	}
	return (
		<h2 style={{ fontWeight: "normal" }}>
			How&nbsp;does Google&nbsp;
			<span style={{ display: "inline", fontWeight: "bold" }}>
				autocomplete
			</span>{" "}
			this&nbsp;query?
		</h2>
	)
}
export default Message
